module.exports = __webpack_public_path__ + "img/Condominio_das_Americas_LazerPiscina.dc61ea65.jpg";